import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const Wrapper = styled.div`
    ${BaseStyle.Mixins.screenSizes.medium} {
        margin: 24px auto;
        width: 100%;
        max-width: 1440px;
    }
`;

export const Header = styled.header`
    background: ${({ theme }) => theme.Surface.primary};
    padding: 0 16px;

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 0 24px;
    }

    @media print {
        display: none;
    }
`;

export const Title = styled.h1`
    margin: 0;
    padding: 16px 0;
`;
